// third-party
import { FormattedMessage } from "react-intl";
// import { useTranslation } from "react-i18next";
// assets

import {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconSettings,
  IconSlideshow,
  IconHome,
  IconHome2,
  IconUser,
  IconGlobe,
  IconKey
} from "@tabler/icons-react"


import { GiPostOffice } from "react-icons/gi";
import { FcDepartment } from "react-icons/fc";
import React, { useState, useEffect, useContext } from "react";


// constant
const icons = {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconSettings
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const application = {
  id: "application",
  title: ["C. ",<FormattedMessage id="administrador" />],
  type: "group",
  icon: <IconSettings />, // Use a valid icon component here
   
  children: [
        {
          id: "divers",
          title: ["A. ", <FormattedMessage id="divers" />],
          type: "collapse",
          icon: icons.IconBasket,
          children: [
            {
              id: "annee_academique",
              title: ["1. ",<FormattedMessage id="annee_academique" />],
              type: "item",
              url: "/AnneeAcademique",
            },
            
            {
              id: "annee_academique_inscription",
              title: ["2. ",<FormattedMessage id="annee_academique_inscription" />],
              type: "item",
              url: "/AnneeAcademiqueIncription",
            },

            {
              id: "turmaAneeAnterieure1",
              title: ["3. ", <FormattedMessage id="turmaAneeAnterieure" />],
              type: "item",
              url: "/turmaAnneeAnterieure",
            },
            
            {
              id: "tauxChange",
              title: ["4. ",<FormattedMessage id="monnaie_e_taux" />],
              type: "item",
              url: "/Monnaie",
            },
            {
              id: "cdastrar_iva1",
              title: ["5. ", <FormattedMessage id="cdastrar_iva" />],
              type: "item",
              url: "/IVACadastro",
            },

           /*  {
              id: "mentionDeliberationSession2",
              title: ["6. ", <FormattedMessage id="mentionDeliberationPointSession2" />],
              type: "item",
              url: "/MentionDeliberationSession2",
            }, */

            {
              id: "controle__paiement_stop2",
              title: ["6. ", <FormattedMessage id="controle__paiement_stop" />],
              type: "item",
              url: "/PautaPaiementControleStop",
            },

           
            {
              id: "MultaCadastro2",
              title: ["7. ", <FormattedMessage id="multa_cadastro_titre" />],
              type: "item",
              url: "/MultaCadastro",
            },

            {
              id: "documentsEtudiantText1",
              title: ["8. ", <FormattedMessage id="documentsEtudiantText" />],
              type: "item",
              url: "/DocumentEtudiantEnregistrer",
            },

            {
              id: "hashTable1",
              title: ["9. ",<FormattedMessage id="total_liquidoi" />],
              type: "item",
              url: "/HashTableList",
            },

            {
              id: "hashTable1",
              title: ["10. ",<FormattedMessage id="total_liquidoi_anulacoes" />],
              type: "item",
              url: "/HashTableListAnulacoes",
            },

          
           /*  {
              id: "passagem_classe_actualizar1",
              title: ["11. ", <FormattedMessage id="passagem_classe_actualizar" />],
              type: "item",
              url: "/resultado-passagem-classe-actualizar",
            },
 */
            {
              id: "importar_dados1",
              title: ["12. ", <FormattedMessage id="importar_dados" />],
              type: "item",
              url: "/AnneeAcademiqueNewImportData",
            },

            {
              id: "moienregistrer1",
              title: ["13. ", <FormattedMessage id="moienregistrer" />],
              type: "item",
              url: "/MonthRegister",
            },

            {
              id: "Apis_banque_Menu2",
              title: ["14. ", <FormattedMessage id="Apis_banque_Menu" />],

              type: "collapse",
            //   icon: IconGlobe,
              children: [
               /*  {
                  id: "bankRegister2",
                  title: ["1. ", <FormattedMessage id="bankRegister" />],
                  type: "item",
                  url: "/banksData/banksRegister",
                }, */

                {
                  id: "formePayment1",
                  title: ["1. ",<FormattedMessage id="formesPayment" />],
                  type: "item",
                  url: "/paiements/FormesPayment",
                },
    
                {
                  id: "bankAPiSimulation",
                  title: ["2. ", <FormattedMessage id="bankAPiSimulationPaymentEstudents" />],
                  type: "item",
                  url: "/banksData/recherchePaimentAPI",
                },
    
                {
                  id: "ddonneeWtudiantForAPi",
                  title: ["3. ", <FormattedMessage id="ddonneeWtudiantForAPi" />],
                  type: "item",
                  url: "/banksData/rechercheStudentInfoAPI",
                },
    
                // app/(secure)/banksData/rechercheStudentIPaymentSimulationnfoAPI
                {
                  id: "simulation1",
                  title: ["4. ", <FormattedMessage id="simulation_paymetByBank" />],
                  type: "item",
                  url: "/banksData/rechercheStudentIPaymentSimulationnfoAPI",
                },
    
              ],
            },


          ],

        
        },

        {
          id: "universite",
          title: ["B. ",  <FormattedMessage id="universite" />],
          type: "collapse",
          icon: IconHome2,
          children: [
            {
              id: "enregisterUniversite",
              title: ["1. ", <FormattedMessage id="enregistrer_universite" />],
              type: "item",
              url: "/universityRegister",
              breadcrumbs: true 
            },
            {
              id: "listUniversites",
              title: ["2. ", <FormattedMessage id="list_universite" />],
              type: "item",
              url: "/universityList",
            },
          ],
        },

        {
          id: "faculte",
          title: ["C. ", <FormattedMessage id="faculte" />],
          type: "collapse",
          icon: GiPostOffice,
          children: [

        {
          id: "faculteEnregistre",
          title: ["1. ", <FormattedMessage id="enregistrer_faculte" />],
          type: "item",
          url: "/FacultyRegister",
        },
        {
          id: "listFacultes",
          title: ["2. ",<FormattedMessage id="lister_faculte" />],
          type: "item",
          url: "/FacultyList",
        },
          ],
        },

        {
          id: "departement",
          title: ["D. ", <FormattedMessage id="departamento" />],
          type: "collapse",
          icon: FcDepartment,
          children: [

        {
          id: "departementEnregistre",
          title: ["1. ", <FormattedMessage id="enregistrer_departement" />],
          type: "item",
          url: "/DepartementRegister",
        },

        {
          id: "listdepartement",
          title: ["2. ",<FormattedMessage id="list_departement" />],
          type: "item",
          url: "/DepartementList",
        },
          ],
        },

        {
          id: "cadastroUsarios",
          title: ["E. ", <FormattedMessage id="usuario" />],
          type: "collapse",
          icon: IconUser,
          children: [
            {
              id: "cadastroUsuarios",
              title: ["1. ", <FormattedMessage id="novo_usuario_menu" />],
              type: "item",
              url: "/UserRegister",
            },

            {
              id: "listagemUsuarios",
              title: ["2. ", <FormattedMessage id="listagem_usuario_menu" />],
              type: "item",
              url: "/UserList",
            },
            {
              id: "mudarsenha",
              title: ["3. ", <FormattedMessage id="mudar__senha__apagar__conta__menuItem" />],
              type: "item",
              url: "/UserMudarSemha",
              // '/user/social-profile/posts'
            },

            {
              id: "utilisateurs-enligne",
              title: ["4. ",<FormattedMessage id="utilisateur__connectes" />],
              type: "item",
              url: "/userEnligne",
              // '/user/social-profile/posts'
            },

            {
              id: "chat_room1",
              title: ["5. ", <FormattedMessage id="chat_room" />],
              type: "item",
              url: "#",
              //               url: "/chat/users/app/form'",

            },

            {
              id: "utilisateurs-enligne",
              title: ["6. ",<FormattedMessage id="utilisateur__connectes" />],
              type: "item",
              url: "/userEnligne",
              // '/user/social-profile/posts'
            },
          
          ],
        },

        {
          id: "cadastroPaisesECidade",
          title: <FormattedMessage id="paisesECidade" />,
          type: "collapse",
          icon: IconGlobe,
          children: [
            {
              id: "enregistrer_paiys1",
              title: ["1. ", <FormattedMessage id="enregistrer_paiys" />],
              type: "item",
              url: "/PaisECidade",
              // '/user/social-profile/posts'
            },

            {
              id: "enregistrer_cidade1",
              title: ["2. ",<FormattedMessage id="enregistrer_cidade" /> ],
              type: "item",
              url: "/PaisECidade2",
              // '/user/social-profile/posts'
            },

          ],
        },

          {
            id: "cadastrarPrivilegios",
            title: ["G. ",<FormattedMessage id="privilegios_visualizar" />],
            type: "collapse",
            icon: IconKey,
            children: [
              {
                id: "privilegeGeral",
                title: ["1. ",<FormattedMessage id="privilegeGeral" />],
                type: "item",
                url: "/privileges/administration",
              },
              {
                id: "privilegeEtudiants1",
                title: ["2. ",<FormattedMessage id="privilegeEtudiants" />],
                type: "item",
                url: "/privileges/etudiants",
              },
              {
                id: "privilegeprofesseurs1",
                title: ["3. ", <FormattedMessage id="privilegeprofesseurs1" />],
                type: "item",
                url: "/privileges/professeurs",
              },
              {
                id: "privilegesCours1",
                title: ["4. ",<FormattedMessage id="privilesCours" />],
                type: "item",
                url: "/privileges/cours",
              },

              {
                id: "privilegesPaiement1",
                title: ["5. ", <FormattedMessage id="privilegesPaiement" />],
                type: "item",
                url: "/privileges/pagamento",
              },
              {
                id: "privilegeCaisse1",
                title: ["6. ",<FormattedMessage id="privilegeCaisse1" />],
                type: "item",
                url: "/privileges/caixa",
              },
                          
            ],
          },
          {
            id: "declaracaoConfig",
            title: ["I. ",<FormattedMessage id="declaracao_config" />],
            type: "collapse",
            icon: IconGlobe,
            children: [
          {
            id: "DeclarationEffet",
            title: ["1. ", <FormattedMessage id="declracao_efeito" />],
            type: "item",
            url: "/declaracao/effetDeclaracao",
          },

          {
            id: "declaracao_assinante1",
            title: ["2. ", <FormattedMessage id="declaracao_assinante" />],
            type: "item",
            url: "/declaracao/assinante",
          },

          {
            id: "numero_declaracao_config1",
            title: ["3. ", <FormattedMessage id="numero_declaracao_config" />],
            type: "item",
            url: "/declaracao/NumeroDeclaration",
          },
        ],
      },

      {
        id: "time_menu_text1",
        title: ["J. ",<FormattedMessage id="time_menu_text" />],
        type: "collapse",
        icon: IconKey,
        children: [

      {
        id: "guide_for_applicatin1",
        title: ["1. ", <FormattedMessage id="guide_for_applicatin" />],
        type: "item",
        url: "/configTimeLines",
      },

      {
        id: "timeline_for_university_operation_config1",
        title: ["2. ", <FormattedMessage id="timeline_for_university_operation_config" />],
        type: "item",
        url: "/configTimeLinesAllConfig",
      },

      {
        id: "tml_control_student1",
        title: ["3. ", <FormattedMessage id="tml_control_student" />],
        type: "item",
        url: "/configTimeLinesForStudent",
      },

      {
        id: "tml_professeur_all_config2",
        title: ["4. ", <FormattedMessage id="tml_professeur_all_config" />],
        type: "item",
        url: "/configTimeLinesForProfessors",
      },

      {
        id: "TimeLineForPointentry2",
        title: ["5. ", <FormattedMessage id="tml_for_point_entry_meny_text" />],
        type: "item",
        url: "/configTimeLinesForPpontEntry",
      },

        ]
      },
      {
        id: "gestao_portaria_entrada1",
        title: ["K. ", <FormattedMessage id="gestao_portaria_entrada" />],
        type: "collapse",
        icon: IconUser,
        children: [

          {
            id: 'criacao_posto_entrada1`',
            title: ["1. ", <FormattedMessage id="criacao_posto_entrada" />],
            type: 'item',
            url: '/accessControl/registerEntrance'
          },
          {
            id: 'controle_securite1`',
            title: ["2. ", <FormattedMessage id="controle_securite1" />],
            type: 'item',
            url: '/accessControl/controlAccessFuturiss'
          },
        
        ],
      },
      
          
      ],
  //  },
//  ],
};

  



export default application;
